<template>
  <div>
    <DropdownConfiguration :controller="FitTypeBaselineCtller" />
    <TextInputConfiguration
      v-if="FitTypeBaselineCtller.valueSelection=== 'Iterative-Poly'"
      :controller="OrderBaseLineMultipleCtrller"
      :sizeinput="'sm'"
      :forcerow="true"
    />
    <TextInputConfiguration
      v-if="FitTypeBaselineCtller.valueSelection==='Iterative-Poly'"
      :controller="SSEBaseLineMultipleCtrller"
      :sizeinput="'sm'"
      :forcerow="true"
    />
    <p
      v-if="RangeMaxBaseLineTextCtrller.value!=='' ||RangeMinBaseLineTextCtrller.value!==''"
      class="range-display expanded-info pt-2"
    >
      <span v-if="RangeMinBaseLineTextCtrller.value!==''">{{ RangeMinBaseLineTextCtrller.value }}&#60;</span>
      <span> t </span>
      <span v-if="RangeMaxBaseLineTextCtrller.value!==''">&#60;{{ RangeMaxBaseLineTextCtrller.value }}</span>
    </p>
    <p
      v-else
      class="range-display expanded-info pt-2"
    >
      Study timeline
    </p>
    <TextInputConfiguration
      :controller="RangeMinBaseLineTextCtrller"
      :sizeinput="'sm'"
      :forcerow="true"
      class="expanded-info m-0"
    />
    <TextInputConfiguration
      :controller="RangeMaxBaseLineTextCtrller"
      :sizeinput="'sm'"
      :forcerow="true"
      class="mb-2 expanded-info m-0"
    />
  </div>
</template>

<script>
import DropdownConfiguration from '@/components/properties/elements/DropdownConfiguration'
import TextInputConfiguration from '@/components/properties/elements/TextInputConfiguration'
import {inputTextConfCtrller,comboBoxConfCtrller} from '@/assets/classes/configuration.js'
import { ConfigName } from '@/common/sharedDefinitions/commonPlotDefinitions'

const rootContextFolder='ReportViewer/Studies/BaseLine/'

export default {
  name: 'BaseLine',
  components:{
    TextInputConfiguration,
    DropdownConfiguration
  },
  props: { 
    sectionconfig:{
      type:String,
      required: true
    }
  },
  data() {
    return {
      BaselineExpanded:true,
      elementsConfig:[],
      FitTypeBaselineCtller: new comboBoxConfCtrller(ConfigName.Baseline_Type,
        [
          {text:'Offset',value:'Offset'},
          {text:'Linear',value:'Linear'},
          {text:'Quadratic',value:'Quadratic'},
          {text:'Inverse square root',value:'Inverse square root'},
          {text:'Semilog x',value:'Semilog x'},
          {text:'Semilog y',value:'Semilog y'},
          {text:'Double log',value:'Double log'},
          {text:'Exponential x',value:'Exponential x'},
          {text:'Exponential y',value:'Exponential y'},
          {text:'Michaelis-Menten',value:'Michaelis-Menten'},
          {text:'Iterative-Polynomial',value:'Iterative-Poly'},
        ],'Fit Baseline',0,rootContextFolder+'FitTypeBaseline'),
      OrderBaseLineMultipleCtrller: new inputTextConfCtrller(ConfigName.OrderBaseLineMultiple,'Order','Please give a numerical value greater than zero','1000',(value)=>{return !isNaN(value) && value>0}),
      SSEBaseLineMultipleCtrller: new inputTextConfCtrller(ConfigName.SSEBaseLineMultiple,'SSE','Please give a numerical value greater than zero','0.01',(value)=>{return !isNaN(value) && value>0}),
      RangeMinBaseLineTextCtrller: new inputTextConfCtrller(ConfigName.rangeMinBL,'Min','Please give a numerical value or leave it empty to consider all the graph','',(value)=>{return !isNaN(value) ||value===''}),
      RangeMaxBaseLineTextCtrller: new inputTextConfCtrller(ConfigName.rangeMaxBL,'Max','Please give a numerical value or leave it empty to consider all the graph','',(value)=>{return !isNaN(value) ||value===''})
    }
  },
  watch:{
    sectionconfig(){
      this.configureStudy()
    }
  },
  created(){
    this.elementsConfig = [
      this.FitTypeBaselineCtller,
      this.OrderBaseLineMultipleCtrller,
      this.SSEBaseLineMultipleCtrller,
      this.RangeMinBaseLineTextCtrller,
      this.RangeMaxBaseLineTextCtrller
    ]
  },
  mounted(){
    this.configureStudy()
  },
  methods:{
    configureStudy(){
      this.elementsConfig.forEach(conf=>conf.configCategory=this.sectionconfig)
      this.elementsConfig.forEach(conf=>conf.setParent(this))
    }
  }
}
</script>

<style>
.range-display{
  font-weight: bold;
  text-align: center;
  font-size: 0.85rem;
}
